<template>
    <div class="row no-gutters body">
        <div class="col-lg-3 middle-background d-none d-lg-block"></div>
        <div class="col-md-12 col-lg-9 middle-background pb-4">
            <div class="row no-gutters">
                <br />
            </div>
            <div class="row no-gutters mt-5 main-card" v-if="!currentUserProfileId && currentUserProfileId === undefined">
                <div class="col-lg-8 pb-3">
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div class="ml-3 mr-3 mt-lg-2">
                        <no-profile-id-component></no-profile-id-component>
                    </div>
                </div>
            </div>
            <div class=" no-gutters mt-5 main-card" v-else >
                <div class="col-lg-12"> 
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div>
                        <div class="col-12 pb-5 mb-4" v-if="requestedResumesLoader">
                            <img src="../assets/pageloader.svg" class="pageloader" alt="loading">
                        </div>
                        <div v-else >
                            <div v-if="requestedResumesList.length > 0" class="d-flex">
                            <div class="col-lg-5 pr-lg-0 col-md-12 pb-5 jobslistverticalscroll" id="jobslistdiv" @scroll="handleScroll">
                            <div v-for="(job, index) in requestedResumesList" :key="index" >
                                <div class="shadow card mr-md-3 ml-md-3 mb-2 pb-2 resumeName pointer" :class="{'borderleftblue' :selectedResumeIndex===index}" @click="viewJobDetails(index, job)">
                                    <div class="p-2 d-flex">      
                                        <div class="">
                                            <div class="borderradius10 mr-2 mt-2 text-center" v-if="job.roleName=='Recruiter'">
                                                <img v-if="job.empProfileLink" :src="job.empProfileLink" class="logoimg img-fluid rounded-circle loadingBgImg" alt="profilepic">
                                                <img v-else src="../assets/Profile_placehlder.svg" class="logoimg img-fluid rounded-circle" alt="profilepic">
                                            </div>
                                            <div class="borderradius10 mr-2 mt-2 text-center" v-else>
                                                <img v-if="job.companyLogo" :src="job.companyLogo" class="logoimg img-fluid rounded-circle loadingBgImg" alt="profilepic">
                                                <img v-else src="../assets/Profile_placehlder.svg" class="logoimg img-fluid rounded-circle" alt="profilepic">
                                            </div>
                                        </div> 
                                        <div class="col-md-11 col-lg-10 pl-0 pr-0 pt-2">
                                            <div class="d-flex justify-content-between">
                                                <div class="col-lg-12 pl-0 pr-0 d-flex">
                                                    <!-- <span class="fontsize16 black proximanova-bold mt-lg-2 pointer text-wrap resumeName nameBlock" @click="viewJobDetails(index, job)">{{job.jobTitle}}</span>   -->
                                                    <span class="col-lg-10 pl-0 pr-0">
                                                    <span class="text-wrap" @click="viewJobDetails(index, job)" v-if="job.roleName=='Recruiter'">
                                                        <span class="fontsize14 black proximanova-semibold mt-1 pointer text-wrap nameBlock">{{job.fullName}}</span>
                                                        <span class="fontsize14 black mt-1 pointer text-wrap nameBlock"> from Team {{job.companyName}}</span>
                                                    </span>
                                                    <span class="text-wrap" @click="viewJobDetails(index, job)" v-else>
                                                        <span class="fontsize14 black proximanova-bold mt-1 pointer text-wrap nameBlock">{{job.companyName}}</span>
                                                    </span>
                                                    <span class="fontsize14 black mt-1 pointer text-wrap nameBlock"> for <span class="proximanova">{{job.jobTitle}}</span></span>
                                                    </span>
                                                    <span class="d-none d-lg-block col-lg-2 pl-0 pr-0" v-if="job.creationDate">
                                                        <span class="black30 proximanova fontsize12 text-nowrap">{{ job.creationDate | moment("from", "now", true)}} Ago</span>
                                                    </span>
                                                </div>
                                                <div class="d-block d-lg-none">
                                                    <span class="proximanova-semibold fontsize12 ml-2 pl-3 pr-3 p-1 mt-2 border-0 backgroundcolor6 green borderradius20" v-if="job.status=='Accepted'">Accepted</span>
                                                    <span class="proximanova-semibold fontsize12 ml-2 pl-3 pr-3 p-1 mt-2 border-0 backgroundcolor7 red borderradius20" v-if="job.status=='Declined'">Declined</span>
                                                    <br>
                                                    <span class="black30 proximanova fontsize12 pull-right pr-3" v-if="job.creationDate">{{ job.creationDate | moment("from", "now", true)}} Ago</span>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column mt-2">
                                                <span class="fontsize12 black80 proximanova" v-if="job.message">{{String(job.message).substring(0,100)}} ...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 pb-5 mb-4" v-if="requestedResumesloadmoreLoader">
                                <img src="../assets/pageloader.svg" class="pageloader" alt="loading">
                            </div>
                            </div>
                            <div class="col-lg-7 col-md-12 pl-0 d-none d-md-none d-lg-block jobslistverticalscroll">
                                <selected-request-resume></selected-request-resume>
                            </div>
                            </div>
                            <div v-else>
                                <div class="ml-3 mr-3">
                                    <no-records-found :message="noRecordsFoundMessage"></no-records-found>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
    </div>
</template>
<script>
import { bus } from "../main";
import httpuserprofile from "@/js/http-userprofile.js";
import httpjob from "@/js/http-postjob.js";
import router from '../router.js'
import SelectedRequestResume from '../components/SelectedRequestResume.vue'
import NoProfileIdComponent from '../components/NoProfileId.vue'
import NoRecordsFound from '../components/NoRecordsFound.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import commonUtils from '@/js/common-utils.js'
import sessionUtils from '@/js/session-util.js'
export default{
    components: {
        SelectedRequestResume,
        NoProfileIdComponent,
        NoRecordsFound,
        APIerrorModal
    },
data(){
    return{
        activeClass: 'Track',
        applyBtnClicked : false,
        noRecordsFoundMessage : 'No records found',
        currentUserProfileId: null,
        currentUserEmail : null,
        isScrolled : false,
        limitCounter : 1,
        displayAPIerrorModal : false,
        requestedResumesLoader : true,
        requestedResumesloadmoreLoader : false,
        selectedResumeIndex : null,
        instancerequestedResumesList : [],
        requestedResumesList : [],
    }
},
methods:{
    closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
    },
    // getting suggested jobs list
    getSuggestedJobsList(){
        httpjob.get('/postjob/getResumeRequestListByProfileId?profileId='+this.currentUserProfileId+'&limitCounter='+this.limitCounter)
        .then(response => {
            this.requestedResumesLoader = false;
            this.requestedResumesloadmoreLoader = false;
            this.isScrolled = false;
            console.log("suggested jobs : ", response) 
            this.instancerequestedResumesList = response.data
            if(this.instancerequestedResumesList.length > 0){
            for(var i =0; i < this.instancerequestedResumesList.length; i++){
                // this.instancerequestedResumesList[i].moremenuname = 'sugJob'+this.instancerequestedResumesList[i].jobId
                this.requestedResumesList.push(this.instancerequestedResumesList[i])
            }
            if(this.requestedResumesList.length > 0 && this.limitCounter === 1){
                this.displayDefaultJobInfo()
            } 
            }     
        }).catch(error=>{   
            this.requestedResumesLoader = false;
            this.requestedResumesloadmoreLoader = false;
            console.log(error);  
        })   
    },
    // this will invoke after getting the initial set of results
        // select first job as a selected job and display the selecetd job information
    displayDefaultJobInfo(){
        var resumes = document.getElementsByClassName('resumeName')
        if(screen.width > 900) {
            setTimeout(function() {
                resumes[0].click()
            },2000);
        }
    },
    // this will invoke after click on job title to display selected job information
    // for large devices sending the required information through bus event
    // for small & medium devices navigate to another page (job_details) to display selected job infromation
    viewJobDetails(index, job){
        this.selectedResumeIndex = index;
        bus.$emit('selectrequestedresume', job.reqId)
        if(screen.width < 900) {
            router.push({
                name : 'selectedresumerequest', params: { id: job.reqId}
            })
        }
    },
    //this will invoke after scrolling down to get more records
    handleScroll () {   
        var myDiv = document.getElementById('jobslistdiv')
        if(screen.width > 800) {
        if(!this.isScrolled){
            if (myDiv.offsetHeight + myDiv.scrollTop + 1 >= myDiv.scrollHeight) {
                if(this.instancerequestedResumesList.length >= 9){
                    this.isScrolled = true;    
                    this.limitCounter = this.limitCounter+1; 
                    this.requestedResumesloadmoreLoader = true;
                    this.getSuggestedJobsList();
                }else{
                    console.log("No more jobs found")
                }                  
            }        
        }    
        }
    },
    //this will invoke after scrolling down to get more records
    handlesmScroll(){
        if(screen.width < 800) {  
        if(!this.isScrolled){               
            if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight)) { 
                if(this.instancerequestedResumesList.length >= 9){
                    this.isScrolled = true;    
                    this.limitCounter = this.limitCounter+1; 
                    this.requestedResumesloadmoreLoader = true;
                    console.log("into normal list")
                    this.getSuggestedJobsList();
                }else{
                    console.log("No more jobs found")
                }             
            }        
        }   
        }
    },
},
mounted(){
    this.currentUserProfileId = sessionUtils.getUserProfileId();
    this.currentUserEmail = sessionUtils.getUserEmail();
    if(this.currentUserProfileId){
    this.getSuggestedJobsList()
    }
},
created(){
   window.addEventListener('scroll', this.handlesmScroll);
},
beforeDestroy(){
    window.removeEventListener('scroll', this.handlesmScroll);
}
}
</script>
<style scoped>
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.resumeName:hover{
    background-color: #e5e6ec;
}
/* .nameBlock:hover{
	color:#007AFF !important;
	text-decoration: underline;
	white-space: nowrap;
} */
.pageloader {
  width: 7%;
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: 46%;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
} 
.main-badge {
    background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%) !important;
    font-size: 12px !important;
    /* opacity: 30%; */
}
.border{
  padding-left: 10px;
}
.logoimg{
    width: 38px;
    height: 38px;
}
@media only screen and (max-width: 600px){
    .nameBlock{
        font-size: 18px !important;
	}
    .pageloader {
        width: 20%;
        margin-left: 40%;
    }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
}
@media screen and (min-width: 770px) {
    .jobslistverticalscroll{
        height: 90vh !important;
        overflow: auto;
    }
    .jobslistverticalscroll::-webkit-scrollbar {
        display: none;
    }
}
@media screen and (min-width: 550px) and (max-width : 768px){
    .logoimg {
        height: 35px;
    }
}
@media screen and (max-width : 550px) {
    .logoimg{
        height: 30px;
    }
}
</style>
